import { applyLinkedPattern, sanitizePattern } from '@/audio/patternModel';
import { INSTRUMENT_COLORS, MAX_TRACKS } from '@/utils/constants';
import { defaultTrackEffects } from '@/state/trackModel';
import { countTrackSlots } from '@/state/classSession';

const trackDefaults = (instrument, name, color, clip) => ({
  id: `track-${crypto.randomUUID()}`, name, instrument, color, volume: 80, pan: 0, muted: false, solo: false,
  effects: defaultTrackEffects(), clips: [clip],
});

function generatedClip(sourceClip, name, pattern, color) {
  const id = crypto.randomUUID();
  const bars = Number(sourceClip.bars || pattern.patternBars || 1);
  return { id: `clip-${id}`, loop_id: `pattern-${id}`, name, color, start_bar: Number(sourceClip.start_bar || 0), bars, offset: 0,
    naturalLoopBars: pattern.patternBars, isWholeLoop: bars === pattern.patternBars, fade_in: 0, fade_out: 0, isPattern: true, audio_url: null, patternType: 'keys', pattern };
}

export function buildMelodyTrack(sourceClip, generated, family = 'trap') {
  const color = INSTRUMENT_COLORS.melody || '#9B5DE5';
  const pattern = sanitizePattern('keys', { patternBars: Number(sourceClip.pattern?.patternBars || sourceClip.bars || 4), notes: generated.notes, voice: ['trap', 'latin', 'dance'].includes(family) ? 'pluck' : 'keys',
    lockToKey: true, melodySeed: generated.melodySeed, melodyRhythm: generated.melodyRhythm, melodyStyle: generated.melodyStyle || generated.style });
  return trackDefaults('melody', 'Melody', color, generatedClip(sourceClip, 'Melody', pattern, color));
}

export function buildBassTrack(sourceClip, generated) {
  const color = INSTRUMENT_COLORS.bass || '#00D4AA';
  const pattern = sanitizePattern('keys', { patternBars: Number(sourceClip.pattern?.patternBars || sourceClip.bars || 4), notes: generated.notes, voice: generated.voice,
    mono: generated.mono, glide: generated.glide, lockToKey: true });
  return trackDefaults('bass', 'Bass', color, generatedClip(sourceClip, 'Bass', pattern, color));
}

export function commitStarterTrack(pushState, arrangement, sourceClip, track, { maxTracks = MAX_TRACKS } = {}) {
  if (countTrackSlots(arrangement.tracks, arrangement.classSession) >= maxTracks) return { ok: false, reason: 'max-tracks', tracks: arrangement.tracks };
  const ownerIndex = arrangement.tracks.findIndex((candidate) => candidate.clips?.some((clip) => clip.id === sourceClip.id));
  const tracks = [...arrangement.tracks]; tracks.splice(ownerIndex >= 0 ? ownerIndex + 1 : tracks.length, 0, track);
  pushState({ tracks, sectionMarkers: arrangement.sectionMarkers });
  return { ok: true, tracks, track };
}

export function commitMelodyIntoClip(pushState, arrangement, clip, generated) {
  const pattern = sanitizePattern(clip.patternType, { ...clip.pattern, notes: generated.notes, lockToKey: true, melodySeed: generated.melodySeed, melodyRhythm: generated.melodyRhythm, melodyStyle: generated.melodyStyle || generated.style });
  const tracks = applyLinkedPattern(arrangement.tracks, clip.loop_id, clip.patternType, pattern);
  pushState({ tracks, sectionMarkers: arrangement.sectionMarkers });
  return { ok: true, tracks, pattern };
}
